export default __webpack_public_path__ + "static/media/Audit.361d8477.jpg";